// extracted by mini-css-extract-plugin
export default {"container":"Bottom_container__2LIEv"};